import React from 'react';
import EditableText from './EditableText';
import EditableImage from './EditableImage';

const renderOrgNameText = (orgName) =>
  orgName ? (
    <div className="cover-page__org-name">
      {orgName.split('\n').map((line, i) => (
        <span key={i}>{line}</span>
      ))}
    </div>
  ) : null;

export default function CoverPage({ data, firstPageData }) {
  const personName = data.projectName || '';
  const subHeadingParts = ((firstPageData && firstPageData.subHeading) || '').split('\n').map(s => s.trim()).filter(Boolean);
  const date = subHeadingParts[2] || '';
  const orgName = (firstPageData && firstPageData.mainHeading) || '';
  const logoUrl = firstPageData && firstPageData.logo;
  const orgImage = firstPageData && firstPageData.orgImage;
  const orgImageWidth = firstPageData && firstPageData.orgImageWidth;
  const orgImageHeight = firstPageData && firstPageData.orgImageHeight;

  return (
    <div className="pdf-page pdf-page--cover">
      <div className="cover-page">
        <div className="cover-page__body">
          <div className="cover-page__logo-section">
            {logoUrl && (
              <img src={logoUrl} alt={orgName} className="cover-page__logo" />
            )}
            <EditableImage
              image={orgImage}
              width={orgImageWidth}
              height={orgImageHeight}
              alt={orgName || ''}
              fallback={renderOrgNameText(orgName)}
              imagePath="firstPage.orgImage"
              widthPath="firstPage.orgImageWidth"
              heightPath="firstPage.orgImageHeight"
              defaultWidth={200}
              defaultHeight={80}
            />
          </div>

          <div className="cover-page__divider" />

          <div className="cover-page__title-section">
            <EditableText
              as="h2"
              className="cover-page__report-title"
              path="firstPage.subHeading.line1"
              variant="inline"
              fallback="360 Insights Report"
            />
            <h1 className="cover-page__person-name">{personName}</h1>
          </div>

          <div className="cover-page__info-box">
            <EditableText
              as="p"
              className="cover-page__confidential"
              path="firstPage.confidentialLabel"
              variant="inline"
              stripInlineWrap
              fallback="CONFIDENTIAL"
            />
            {date && <p className="cover-page__date">{date}</p>}
          </div>
        </div>

        <div className="pdf-page__footer cover-page__footer">
          <div className="pdf-page__footer-left">
            {logoUrl
              ? <img src={logoUrl} alt="" className="cover-page__footer-logo" />
              : <span className="pdf-page__footer-company">Culturebie</span>
            }
          </div>
          <div className="pdf-page__footer-center">
            <span className="cover-page__footer-page-num">1</span>
          </div>
          <div className="pdf-page__footer-right">
            <span>Culturebie</span>
          </div>
        </div>
      </div>
    </div>
  );
}
